import { useNavigate, useParams, useLocation } from "react-router-dom";
import "../assets/css/newstudent.css";
import { FaRegClock } from "react-icons/fa6";
import Navbar from "../components/Navbar";

import anaestheticImg from "../assets/images/anaesthetic.jpg";
import communityImg from "../assets/images/community.jpg";
import biomedicalImg from "../assets/images/biomedical.jpg";
import healthinfoImg from "../assets/images/healthinfo.jpg";
import socialworkImg from "../assets/images/socialwork.jpg";
import midwiferyImg from "../assets/images/midwifery.jpg";
import nursingImg from "../assets/images/nursing.jpg";
import postbasicImg from "../assets/images/postbasic.jpg";

const schoolData = {
  biomedical: [
    {
      name: "Biomedical Engineering (ND)",
      duration: "24 Months",
      description:
        "National Diploma in Federal School of Biomedical Engineering",
    },
    {
      name: "Biomedical Engineering (HND)",
      duration: "24 Months",
      description:
        "Higher National Diploma in Federal School of Biomedical Engineering",
    },
  ],

  anaesthetic: [
    {
      name: "Anaesthetic Technicians",
      duration: "3 Years",
      description: "Anaesthetic Technicians Training Programme in LUTH",
    },
  ],

  community: [
    {
      name: "School of Community Health",
      duration: "24 Months",
      description: "Higher Diploma in Community Health Extension Work",
    },
    {
      name: "School of Community Health II",
      duration: "12 Months",
      description: "Higher Diploma in Community Health Officers Programme",
    },
  ],

  healthinfo: [
    {
      name: "School of Health Information Management (ND)",
      duration: "2 Years",
      description: "National Diploma in Health Information Management",
    },
    {
      name: "School of Health Information Management (HND)",
      duration: "2 Years",
      description: "Higher National Diploma in Health Information Management",
    },
  ],

  socialwork: [
    {
      name: "Medical and Psychiatry Social Work",
      duration: "12 Months",
      description: "School of Medical and Psychiatry Social Work",
    },
  ],
};

const collegeOfNursingDepartments = [
  {
    key: "nursing-sciences",
    name: "Department of Nursing Sciences",
    img: nursingImg,
    description:
      "Basic nursing training leading to the Department of Nursing Sciences programme.",
    programmes: [
      {
        name: "Department of Nursing Sciences",
        duration: "4 Years",
        description: "Basic Nursing Programme",
      },
    ],
  },
  {
    key: "post-basic-nursing",
    name: "Department of Post Basic Nursing",
    img: postbasicImg,
    description: "Specialist post-basic nursing programmes.",
    programmes: [
      {
        name: "Perioperative Nursing",
        duration: "12 Months",
        description: "Surgical and theatre nursing training",
      },
      {
        name: "Accident & Emergency",
        duration: "12 Months",
        description: "Emergency response and trauma nursing",
      },
      {
        name: "Paediatric Nursing",
        duration: "12 Months",
        description: "Nursing care for children and adolescents",
      },
      {
        name: "Ophthalmic Nursing",
        duration: "12 Months",
        description: "Eye care and visual health nursing",
      },
      {
        name: "Neonatal Nursing",
        duration: "12 Months",
        description: "Care of newborn and high-risk infants",
      },
      {
        name: "Nephrology Nursing",
        duration: "12 Months",
        description: "Renal and dialysis nursing practice",
      },
      {
        name: "Critical Care Nursing",
        duration: "12 Months",
        description: "Intensive and critical care nursing",
      },
      {
        name: "Dental Nursing",
        duration: "12 Months",
        description: "Dental and oral healthcare nursing",
      },
    ],
  },
  // {
  //   key: "midwifery",
  //   name: "Department of Midwifery",
  //   img: midwiferyImg,
  //   description: "Midwifery training and maternal health care.",
  //   programmes: [
  //     {
  //       name: "Midwifery",
  //       duration: "18 Months",
  //       description: "Department of Midwifery programme",
  //     },
  //   ],
  // },
];

const schoolCards = {
  nursing: {
    name: "Department of Nursing Sciences",
    departments: collegeOfNursingDepartments,
  },
  biomedical: {
    name: "Federal School of Biomedical Engineering",
    img: biomedicalImg,
  },
  anaesthetic: {
    name: "Anaesthetic Technicians",
    img: anaestheticImg,
  },
  community: {
    name: "School of Community Health",
    img: communityImg,
  },
  healthinfo: {
    name: "School of Health Information Management",
    img: healthinfoImg,
  },
  socialwork: {
    name: "School of Medical and Psychiatry Social Work",
    img: socialworkImg,
  },
};

const SchoolPage = () => {
  const navigate = useNavigate();
  const { schoolKey, departmentKey } = useParams();
  const { state } = useLocation();

  const school = schoolCards[schoolKey];
  const isNursing = schoolKey === "nursing";
  const selectedDepartment = isNursing
    ? collegeOfNursingDepartments.find((d) => d.key === departmentKey)
    : null;

  const readableName =
    state?.schoolName ||
    school?.name ||
    schoolKey
      ?.replace(/([A-Z])/g, " $1")
      .replace("-", " ")
      .replace(/\b\w/g, (l) => l.toUpperCase());

  const showDepartments = isNursing && !departmentKey;
  const showDepartmentProgrammes =
    isNursing && departmentKey && selectedDepartment;

  const handleProgrammeClick = (
    programme,
    schoolName,
    duration,
    applicationSchoolName = schoolName,
  ) => {
    navigate("/programme", {
      state: {
        programme,
        schoolName,
        duration,
        applicationSchoolName,
      },
    });
  };

  return (
    <>
      <Navbar />
      <div className="newstudents-wrapper">
        <div className="subschool-title-banner">
          <h1 className="subschool-title">{readableName}</h1>
        </div>

        <div className="subschool-wrapper">
          {isNursing && showDepartments && (
            <>
              <p className="subschool-description">
                Select a department under the Department of Nursing Sciences.
              </p>

              <div className="subschool-card-container">
                {school.departments.map((dept) => (
                  <div className="subschool-card" key={dept.key}>
                    <img
                      src={dept.img}
                      alt={dept.name}
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                        borderRadius: "12px",
                        marginBottom: "12px",
                      }}
                    />
                    <h2>{dept.name}</h2>
                    <p className="program-description">{dept.description}</p>
                    <hr className="card-divider" />
                    <div className="duration-row">
                      <span className="time-icon">
                        <FaRegClock />
                      </span>
                      <span className="duration-text">
                        {dept.key === "nursing-sciences"
                          ? "4 Years"
                          : dept.key === "midwifery"
                            ? "18 Months"
                            : "12 Months"}
                      </span>
                    </div>
                    <button
                      className="subschool-register-btn"
                      onClick={() =>
                        navigate(`/school/nursing/${dept.key}`, {
                          state: {
                            schoolName: "Department of Nursing Sciences",
                            departmentName: dept.name,
                          },
                        })
                      }
                    >
                      View Schools
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}

          {showDepartmentProgrammes && (
            <>
              <p className="subschool-description">
                Available programmes in{" "}
                <strong>{selectedDepartment.name}</strong>.
              </p>

              <div className="subschool-card-container">
                {selectedDepartment.programmes.map((item, index) => (
                  <div className="subschool-card" key={index}>
                    <img
                      src={selectedDepartment.img}
                      alt={item.name}
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                        borderRadius: "12px",
                        marginBottom: "12px",
                      }}
                    />
                    <h2>{item.name}</h2>
                    <p className="program-description">{item.description}</p>
                    <hr className="card-divider" />
                    <div className="duration-row">
                      <span className="time-icon">
                        <FaRegClock />
                      </span>
                      <span className="duration-text">{item.duration}</span>
                    </div>
                    <button
                      className="subschool-register-btn"
                      onClick={() =>
                        handleProgrammeClick(
                          item.name,
                          selectedDepartment.name,
                          item.duration,
                          item.name, // send "Accident & Emergency", "Paediatric Nursing", etc.
                        )
                      }
                    >
                      View School
                    </button>
                  </div>
                ))}
              </div>

              <div style={{ marginTop: "20px" }}>
                <button
                  className="subschool-register-btn"
                  onClick={() =>
                    navigate("/school/nursing", {
                      state: { schoolName: "Department of Nursing Sciences" },
                    })
                  }
                >
                  ← Back to Departments
                </button>
              </div>
            </>
          )}

          {!isNursing && (
            <>
              <p className="subschool-description">
                Explore the available programmes and duration below. Click
                register to proceed with application.
              </p>

              <div className="subschool-card-container">
                {schoolData[schoolKey] ? (
                  schoolData[schoolKey].map((item, index) => (
                    <div className="subschool-card" key={index}>
                      <h2>{item.name}</h2>
                      <p className="program-description">{item.description}</p>
                      <hr className="card-divider" />
                      <div className="duration-row">
                        <span className="time-icon">
                          <FaRegClock />
                        </span>
                        <span className="duration-text">{item.duration}</span>
                      </div>
                      <button
                        className="subschool-register-btn"
                        onClick={() =>
                          handleProgrammeClick(
                            item.name,
                            readableName,
                            item.duration,
                          )
                        }
                      >
                        View School
                      </button>
                    </div>
                  ))
                ) : (
                  <div className="subschool-card">
                    <h2>{readableName}</h2>
                    <hr className="card-divider" />
                    <div className="duration-row">
                      <span className="time-icon">
                        <FaRegClock />
                      </span>
                      <span className="duration-text">N/A</span>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SchoolPage;
